<template>
  <Head />
  <router-view/>
  <Footer />
</template>
<script>
import Head from './components/Head';
import Footer from './components/Footer';

export default {
  components: {
    Head,
    Footer,
  },
  setup() {
  },
}
</script>
<style lang="scss">
* {
  transition: all .25s ease-in-out;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

html, body {
  background-color: #ffffff;
  margin: 0;
  padding: 0;
  padding: 15px 30px;
  min-height: 100vh;
  width: 100%;
  font-size: 16px;
  color: #333;
}

#app {
  font-family: YoungSerif-Regular, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 1280px;
  margin: 0 auto;
  background-color: #ffffff;
  min-height: 100vh;
}

// Add a subtle animation for page transitions
.router-view-transition {
  transition: opacity 0.3s ease;
}

.router-view-enter-from,
.router-view-leave-to {
  opacity: 0;
}

/* Intermediate breakpoint for better scaling */
@media (min-width: 769px) and (max-width: 1024px) {
  html, body {
    padding: 12px 20px;
    font-size: 15px;
  }
  
  #app {
    max-width: 100%;
  }
}

@media (max-width: $tabletSize) {
  html, body {
    padding: 10px;
    font-size: 15px;
  }
}

/* iOS font rendering fix */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  @supports (font: -apple-system-body) and (-webkit-appearance: none) {
    html, body {
      -webkit-text-size-adjust: 100%;
      text-size-adjust: 100%;
    }
    
    #app {
      /* Force font rendering */
      -webkit-backface-visibility: hidden;
    }
  }
}
</style>
